"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
const navItems_1 = __importDefault(require("../navItems"));
const react_router_dom_1 = require("react-router-dom");
exports.default = connector(({}) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [navToggle, setNavToggle] = (0, react_1.useState)(false);
    const [contentAnimation, setContentAnimation] = (0, react_1.useState)(false);
    const [markerAnimation, setMarkerAnimation] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const markerTimeOut = setTimeout(() => {
            setMarkerAnimation(true);
        }, 500);
        const contentTimeout = setTimeout(() => {
            setContentAnimation(true);
        }, 500);
        return () => {
            clearTimeout(contentTimeout);
            clearTimeout(markerTimeOut);
        };
    }, []);
    function navToggleHandler() {
        setNavToggle((prevState) => !prevState);
    }
    return (react_1.default.createElement("div", { className: "mobile_nav_main_container" },
        react_1.default.createElement("div", { className: "mobile_nav" },
            react_1.default.createElement("div", { className: "mobile_nav_inner_container" },
                react_1.default.createElement("div", { onClick: navToggleHandler, className: "menu_icon_container" },
                    react_1.default.createElement("img", { src: "/assets/images/mobile_hero_icon.svg", alt: "hero_logo_icon" })),
                react_1.default.createElement("div", { className: "mobile_hero_icon_mask" }),
                react_1.default.createElement("div", { className: `info_inner_container info_inner_container_mobile ${contentAnimation ? "content_animation" : ""}` },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                        } },
                        react_1.default.createElement("h2", null, "Terms & Conditions"))),
                react_1.default.createElement("div", { className: "hero_bottom_scroll_container", style: { bottom: "28%" }, onClick: () => {
                        var _a;
                        (_a = document.getElementById("terms-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                    } },
                    react_1.default.createElement("img", { src: "/assets/images/down_arrow.svg", alt: "" }))),
            react_1.default.createElement("div", { className: `mobile_nav_list_container ${navToggle ? "mobile_nav_active" : ""}` },
                react_1.default.createElement("div", { style: { width: "100%", textAlign: "end" } },
                    react_1.default.createElement("button", { style: {
                            background: "transparent",
                            border: "none",
                            marginRight: "20px",
                        }, onClick: navToggleHandler },
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "#ffffff", style: { width: "32px", height: "32px" } },
                            react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18 18 6M6 6l12 12" })))),
                react_1.default.createElement("ul", { className: "mobile_nav_lists" }, (0, navItems_1.default)().map((item, i) => (react_1.default.createElement("li", { key: i, onClick: () => {
                        var _a;
                        navigate(item.path);
                        if (item.id) {
                            (_a = document.getElementById(item.id)) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                        }
                    } }, item.name)))),
                react_1.default.createElement("button", { className: "hero_top_button", onClick: () => {
                        navigate("/" /* RoutePath.HOME */, {
                            state: {
                                scrollToElement: "contact-us-container",
                            },
                        });
                    } }, "Contact Us")),
            react_1.default.createElement("div", { className: "mobile_hero_bottom_finishing" }))));
});
